// extracted by mini-css-extract-plugin
module.exports = {"maneuversList":"CharacterBuilderClassManeuvers_maneuversList_2D-5f"};